function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import ColorIcon from "../ui/feather-icon/ColorIcon";
import FlexJustified from "../ui/containers/flex-boxes/FlexJustified";
import IconButton from "noood/comp/button/IconButton";
export default function APIProcessorFeedback(props) {
  var _response$error, _response$success, _response$error$lengt, _response$error2, _response$success$len, _response$success2, _response$error3, _response$success3, _response$warning, _response$success4, _response$warning2, _response$error4;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    response = _useState2[0],
    set_response = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    set_height = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    elapsed = _useState6[0],
    setElapsed = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    countdownLength = _useState8[0],
    setCountdownLength = _useState8[1];
  var _useState9 = useState(100),
    _useState0 = _slicedToArray(_useState9, 2),
    progressWidth = _useState0[0],
    setProgressWidth = _useState0[1];
  useEffect(function () {
    if (props.res) {
      set_response(props.res);
      set_height(100);
      setTimeout(function () {
        setProgressWidth(0);
      }, 100);
      setTimeout(function () {
        set_response(undefined);
      }, 5100);
    }
    return function () {
      set_response(undefined);
      setProgressWidth(100);
      set_height(0);
    };
  }, [props.res]);
  var status = "success";
  var bg_color = '#f6f6f6';
  switch (props.status) {
    case 'error':
      bg_color = '#F6F6F6';
      break;
    case 'warning':
      bg_color = '#F6F6F6';
      break;
    case 'unknown':
      bg_color = '#F6F6F6';
      break;
  }
  if ((response === null || response === void 0 || (_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.length) > 0 && (response === null || response === void 0 || (_response$success = response.success) === null || _response$success === void 0 ? void 0 : _response$success.length) > 0) {
    bg_color = '#f6f6f6';
    status = "mixed";
  }
  var total_msgs = Number((_response$error$lengt = response === null || response === void 0 || (_response$error2 = response.error) === null || _response$error2 === void 0 ? void 0 : _response$error2.length) !== null && _response$error$lengt !== void 0 ? _response$error$lengt : 0) + Number((_response$success$len = response === null || response === void 0 || (_response$success2 = response.success) === null || _response$success2 === void 0 ? void 0 : _response$success2.length) !== null && _response$success$len !== void 0 ? _response$success$len : 0);
  var hasSuccess = false;
  var hasErrors = false;
  var hasWarnings = false;
  var isMixed = false;
  if ((response === null || response === void 0 || (_response$error3 = response.error) === null || _response$error3 === void 0 ? void 0 : _response$error3.length) > 0) hasErrors = true;
  if ((response === null || response === void 0 || (_response$success3 = response.success) === null || _response$success3 === void 0 ? void 0 : _response$success3.length) > 0) {
    hasSuccess = true;
    if (hasErrors) isMixed = true;
  }
  if ((response === null || response === void 0 || (_response$warning = response.warning) === null || _response$warning === void 0 ? void 0 : _response$warning.length) > 0) {
    hasWarnings = true;
    if (hasErrors || hasSuccess) {
      isMixed = true;
    }
  }
  if (!hasErrors && !hasSuccess && !hasWarnings) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FlexJustified, {
    className: 'hover-parent',
    style: _objectSpread({
      padding: "20px",
      backgroundColor: bg_color,
      gap: 10,
      borderRadius: 0
    }, props.style)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "60px"
    }
  }, hasSuccess && !hasErrors && !hasWarnings && /*#__PURE__*/React.createElement(ColorIcon, {
    icon: "check",
    size: 60
  }), !hasSuccess && hasErrors && !hasWarnings && /*#__PURE__*/React.createElement(ColorIcon, {
    icon: "x",
    size: 60,
    background_color: "#d53737"
  }), !hasErrors && !hasSuccess && hasWarnings && /*#__PURE__*/React.createElement(ColorIcon, {
    icon: "flag",
    size: 60,
    background_color: "#e58e3c"
  }), isMixed && /*#__PURE__*/React.createElement(ColorIcon, {
    icon: "minus",
    size: 60,
    background_color: "#a0a199"
  }), status === void 0 || status === "unknown" && /*#__PURE__*/React.createElement(ColorIcon, {
    icon: "minus",
    size: 60,
    background_color: "#646464"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: "20px",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: total_msgs > 1 ? 'square' : 'none',
      padding: 0,
      margin: 0
    }
  }, response === null || response === void 0 || (_response$success4 = response.success) === null || _response$success4 === void 0 ? void 0 : _response$success4.map(function (msg, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: "fb-succ-".concat(idx),
      style: {
        color: "#2f851e"
      }
    }, msg);
  }), response === null || response === void 0 || (_response$warning2 = response.warning) === null || _response$warning2 === void 0 ? void 0 : _response$warning2.map(function (warn, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: "fb-warn-".concat(idx),
      style: {
        color: "#b6612c"
      }
    }, warn);
  }), response === null || response === void 0 || (_response$error4 = response.error) === null || _response$error4 === void 0 ? void 0 : _response$error4.map(function (err, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: "fb-err-".concat(idx),
      style: {
        color: "#9d2020"
      }
    }, err);
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      height: "100%",
      display: "flex",
      alignItems: "top"
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: "hover-child",
    icon: "x",
    __click: function __click() {
      set_response(undefined);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      height: "2px",
      backgroundColor: "#ccc",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "2px",
      backgroundColor: "var(--accent)",
      width: "".concat(progressWidth, "%"),
      transition: "width 5s linear"
    }
  })));
}
APIProcessorFeedback.propTypes = {
  res: PropTypes.object // this is the response from the api
  ,
  closeAfterNSeconds: PropTypes.number
};
APIProcessorFeedback.defaultProps = {
  closeAfterNSeconds: 7
};